export const messages = {
    "shared-link.footer.link.install": "Essayer {brandName} gratuitement",
    "shared-link.footer.link.mobile": "{brandName} pour mobile",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Données protégées",
    "shared-link.password-dialog-box.message": "Veuillez indiquer le mot de passe pour accéder aux données partagées",
    "shared-link.password-dialog-box.hint.password": "Mot de passe",
    "shared-link.password-dialog-box.message.invalid-password": "Mot de passe incorrect",
    "shared-link.form.button.open": "Ouvrir",
    "shared-link.page-not-found.title": "Page introuvable",
    "shared-link.page-not-found.message.main": "La page que vous cherchiez est introuvable.",
    "shared-link.page-not-found.message.description": "Il se peut que le lien soit obsolète ou que vous ayez mal saisi l'adresse.",
    "shared-link.page-not-found.message.error": "Code d'erreur : 404",
    "shared-link.restore-file.label.size": "Taille",
    "shared-link.restore-file.button.restore": "Télécharger",
    "shared-link.links-table.column.name": "Nom",
    "shared-link.links-table.column.size": "Taille",
    "shared-link.links-table.action.restore": "Télécharger",
    "shared-link.links-table.action.restore-all": "Télécharger tout",
    "shared-link.side-bar.selected.title:plural": "{count} éléments sélectionnés | {count} élément sélectionné | {count} éléments sélectionnés",
    "shared-link.links-table.label.size": "Taille",
    "shared-link.links-table.message.empty-folder": "Ce dossier est vide"
};
